import { render, staticRenderFns } from "./ClaimProfileDialog.vue?vue&type=template&id=24c4d694&scoped=true"
import script from "./ClaimProfileDialog.vue?vue&type=script&lang=js"
export * from "./ClaimProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./ClaimProfileDialog.vue?vue&type=style&index=0&id=24c4d694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c4d694",
  null
  
)

export default component.exports